// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_j5-6";
export var emphasizeQuantity = "_j5-3";
export var flatBottomCorners = "_j5-5";
export var productImage = "_j5-0";
export var quantityContainer = "_j5-2";
export var tooltip = "_j5-1";
export var wrapAndEllipsesOverflow = "_j5-4";